import {
  Theme,
  useTheme,
  AppBar,
  Paper,
  Divider,
  Stack,
  Container,
} from "fashion/fabrics";
import CodexLauncher from "nodes/codex/CodexLauncher";
import CodexCollections from "nodes/codex/CodexCollections";
import CodexConcept from "nodes/codex/CodexConcept";
import CodexDigitalPricing from "nodes/codex/CodexDigitalPricing";
import CodexPhysicalPricing from "nodes/codex/CodexPhysicalPricing";
import CodexGetStarted from "nodes/codex/CodexGetStarted";
import CodexContact from "nodes/codex/CodexContact";
import CodexMakingProcess from "nodes/codex/CodexMakingProcess";
import CodexDisclaimer from "nodes/codex/CodexDisclaimer";
import CodexToolbar from "nodes/codex/CodexToolbar";
import usePageTitle from "gears/usePageTitle";

const BG_GRADIENT_LIGHT = "linear-gradient(135deg, #f9fbfd, #f2f8ff)";
const BG_GRADIENT_DARK = "linear-gradient(135deg, #303030, #202020";

const getBackgroundGradient = (theme: Theme) =>
  theme.palette.mode === "light" ? BG_GRADIENT_LIGHT : BG_GRADIENT_DARK;

const CodexOutlet = () => {
  usePageTitle("Card Memoir Concept");
  const theme = useTheme();
  return (
    <Paper sx={{ background: getBackgroundGradient(theme) }}>
      <AppBar
        position="fixed"
        color="secondary"
        sx={{ background: getBackgroundGradient(theme) }}
      >
        <CodexToolbar />
      </AppBar>
      <Container sx={{ pt: 10, pb: 2 }}>
        <Stack gap={{ xs: 6, sm: 8 }}>
          <CodexLauncher />
          <Divider variant="middle" />
          <CodexGetStarted />
          <Divider variant="middle" />
          <CodexCollections />
          <Divider variant="middle" />
          <CodexDigitalPricing />
          <Divider variant="middle" />
          <CodexPhysicalPricing />
          <Divider variant="middle" />
          <CodexMakingProcess />
          <Divider variant="middle" />
          <CodexConcept />
          <Divider variant="middle" />
          <CodexContact />
          <Divider variant="middle" />
          <CodexDisclaimer />
          <Divider variant="middle" />
        </Stack>
      </Container>
    </Paper>
  );
};

export default CodexOutlet;
